/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMemberFieldTypes } from './WebApiModelsEnumerationTypesMemberFieldTypes';
import {
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSON,
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSONTyped,
    WebApiModelsEnumerationTypesMemberFieldTypesToJSON,
} from './WebApiModelsEnumerationTypesMemberFieldTypes';
import type { WebApiModelsEnumerationTypesUiControl } from './WebApiModelsEnumerationTypesUiControl';
import {
    WebApiModelsEnumerationTypesUiControlFromJSON,
    WebApiModelsEnumerationTypesUiControlFromJSONTyped,
    WebApiModelsEnumerationTypesUiControlToJSON,
} from './WebApiModelsEnumerationTypesUiControl';

/**
 * 
 * @export
 * @interface WebApiCustomListFieldsDtoCustomFieldUploadDto
 */
export interface WebApiCustomListFieldsDtoCustomFieldUploadDto {
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberFieldTypes}
     * @memberof WebApiCustomListFieldsDtoCustomFieldUploadDto
     */
    fieldType?: WebApiModelsEnumerationTypesMemberFieldTypes;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListFieldsDtoCustomFieldUploadDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListFieldsDtoCustomFieldUploadDto
     */
    customFieldName?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesUiControl}
     * @memberof WebApiCustomListFieldsDtoCustomFieldUploadDto
     */
    uiControl?: WebApiModelsEnumerationTypesUiControl;
}

/**
 * Check if a given object implements the WebApiCustomListFieldsDtoCustomFieldUploadDto interface.
 */
export function instanceOfWebApiCustomListFieldsDtoCustomFieldUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListFieldsDtoCustomFieldUploadDtoFromJSON(json: any): WebApiCustomListFieldsDtoCustomFieldUploadDto {
    return WebApiCustomListFieldsDtoCustomFieldUploadDtoFromJSONTyped(json, false);
}

export function WebApiCustomListFieldsDtoCustomFieldUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListFieldsDtoCustomFieldUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldType': !exists(json, 'fieldType') ? undefined : WebApiModelsEnumerationTypesMemberFieldTypesFromJSON(json['fieldType']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'customFieldName': !exists(json, 'customFieldName') ? undefined : json['customFieldName'],
        'uiControl': !exists(json, 'uiControl') ? undefined : WebApiModelsEnumerationTypesUiControlFromJSON(json['uiControl']),
    };
}

export function WebApiCustomListFieldsDtoCustomFieldUploadDtoToJSON(value?: WebApiCustomListFieldsDtoCustomFieldUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldType': WebApiModelsEnumerationTypesMemberFieldTypesToJSON(value.fieldType),
        'id': value.id,
        'customFieldName': value.customFieldName,
        'uiControl': WebApiModelsEnumerationTypesUiControlToJSON(value.uiControl),
    };
}

